<template>
  <div class="role_warp">
    <!-- 头部工具栏 -->
    <div class="role_heard_tool">
      <el-button
        type="primary"
        class="edit-button"
        size="mini"
        @click="open('add')"
        >添加</el-button
      >
      <el-button type="success" size="mini" @click="getList">刷新</el-button>
      <!-- <el-button
        type="primary"
        class="edit-button"
        size="mini"
        
        style="margin-left: 10px"
        @click="select()"
        >筛选</el-button
      > -->
      <el-button
        slot="reference"
        type="danger"
        size="mini"
        style="margin-left: 10px"
        @click="openDelete"
        >删除</el-button
      >
    </div>
    <!-- <div class="head_search">
      <div class="item_warp">
        <label style="margin: 0 10px;">编号</label>
        <el-input
          v-model="sn"
          placeholder="请输入编号"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
      <div class="item_warp">
        <label style="margin: 0 10px;">语种</label>
        <el-input
          v-model="lang"
          placeholder="请输入语种"
          style="width: 120px"
          size="mini"
          clearable
        />
      </div>
    </div> -->
    <!-- 表单 -->
    <el-table
      ref="gridTable"
      v-loading="loading"
      :data="tableData"
      tooltip-effect="dark"
      :stripe="true"
      :border="true"
      height="calc(100vh - 240px )"
      style="width: 811px"
      size="mini"
      @selection-change="handleSelectionChange"
    >
      <el-table-column type="selection" width="50" />
      <el-table-column prop="address" label="操作" width="100">
        <template slot-scope="scope">
          <el-button
            type="primary"
            class="edit-button"
            size="mini"
            @click="edit(scope.row)"
            >编辑</el-button
          >
        </template>
      </el-table-column>
      <el-table-column prop="num" label="轮次" width="100" />
      <el-table-column prop="amount1" label="第1天" width="80" />
      <el-table-column prop="amount2" label="第2天" width="80" />
      <el-table-column prop="amount3" label="第3天" width="80" />
      <el-table-column prop="amount4" label="第4天" width="80" />
      <el-table-column prop="amount5" label="第5天" width="80" />
      <el-table-column prop="amount6" label="第6天" width="80" />
      <el-table-column prop="amount7" label="第7天" width="80" />
    </el-table>
    <!-- 分页 -->
    <pagination
      v-show="total > 0"
      :total="total"
      :page.sync="pageNum"
      :limit.sync="pageSize"
      @pagination="getList"
    />

    <!-- 添加用户弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      width="900px"
      title="添加"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="active" label-width="90px" size="mini">
        <el-form-item label="轮次">
          <el-input v-model="active.num" placeholder="轮次" />
        </el-form-item>
        <el-form-item
          :label="`第${index + 1}天`"
          style="padding-bottom: 20px; border-bottom: 1px solid #cccccc"
          v-for="(item, index) in active.signData"
          :key="index"
        >
          <div class="flex" style="align-items: center">
            <div>
              <span style="margin-right: 10px">奖励</span>
              <el-input
                v-model="item.amount"
                style="width: 60px; margin-right: 10px"
                placeholder=""
              />
              <span style="margin-right: 20px">USDT</span>
            </div>
            <div class="flex">
              <div style="margin-right: 10px">需邀请下级数量</div>
              <div style="margin-right: 10px">
                <el-input
                  v-model="item.c0"
                  style="width: 60px"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定添加？" @confirm="bannerSave()">
            <el-button slot="reference" type="primary" class="edit-button"
              >添加</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 编辑用户弹窗 -->
    <el-dialog
      :visible.sync="edit_dialogVisible"
      width="900px"
      title="编辑"
      :before-close="editClose"
      :close-on-click-modal="false"
    >
      <!-- 表单 -->
      <el-form ref="form" :model="editForm" label-width="90px" size="mini">
        <el-form-item label="轮次">
          <el-input v-model="editForm.num" placeholder="轮次" />
        </el-form-item>
        <el-form-item
          :label="`第${index + 1}天`"
          style="padding-bottom: 20px; border-bottom: 1px solid #cccccc"
          v-for="(item, index) in editForm.signData"
          :key="index"
        >
          <div class="flex" style="align-items: center">
            <div>
              <span style="margin-right: 10px">奖励</span>
              <el-input
                v-model="item.amount"
                style="width: 60px; margin-right: 10px"
                placeholder=""
              />
              <span style="margin-right: 20px">USDT</span>
            </div>
            <div class="flex">
              <div style="margin-right: 10px">需邀请下级数量</div>
              <div style="margin-right: 10px">
                <el-input
                  v-model="item.c0"
                  style="width: 60px"
                  placeholder=""
                />
              </div>
            </div>
          </div>
        </el-form-item>
        <el-form-item>
          <el-popconfirm title="确定更新？" @confirm="update()">
            <el-button slot="reference" type="primary" class="edit-button"
              >更新</el-button
            >
          </el-popconfirm>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination"; // 引入分页器
import UploadImage from "@/components/Upload/UploadPic"; // 引入分页器
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module

import validEmail from "@/utils/validate"; // 引入邮箱验证方法
import md5 from "js-md5"; // 引入Md5加密

export default {
  name: "Management",
  components: { Pagination, VueUeditorWrap, UploadImage },
  data() {
    return {
      option: "", // 初始选项
      options: [], // 选择角色
      name: "", // 搜索的管理员名称
      tableData: [], // 展示的表单信息
      // 添加表单
      active: {
        num: "",
        signData: [
          {
            day: 1,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 2,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 3,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 4,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 5,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 6,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 7,
            amount: 0,
            level: 0,
            c0: 0,
          },
        ],
      },
      // 修改表单
      editForm: {
        num: "",
        signData: [],
      },
      total: 0, // 总数
      pageNum: 1, // 页码值
      pageSize: 20, // 页大小
      multipleSelection: [], // 选中项s
      yiFangDetailList: [], //
      dialogVisible: false, // 添加弹窗
      dialog: false, // 添加弹窗
      edit_dialogVisible: false, // 编辑弹窗
      Isedit: false, // 是否是编辑弹窗
      loading: false, // 表格加
      buttongLoding: false, // 按钮加载
      sn: "",
      lang: "en",
      isEnabled: false,
      isChat: false,
      isTelegram: false,
      isWhatsApp: false,
      isMessenger: false,
      isLinkUrl: false,
      isTelegramGroup: false,
      dataTime: ["", ""],
      yifangId: "",
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleClickItem() {
      this.$nextTick(() => {
        // 获取遮罩层dom
        const domImageMask = document.querySelector(".el-image-viewer__mask");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", () => {
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });
      });
    },
    // 打开编辑弹窗
    edit(row) {
      let editForm = JSON.parse(JSON.stringify(row));
      let editForm1 = {
        num: "",
        signData: [],
      };
      this.edit_dialogVisible = true;
      editForm1.num = editForm.num;
      editForm1.id = editForm.id;
      editForm1.signData.push(JSON.parse(editForm.a1));
      editForm1.signData.push(JSON.parse(editForm.a2));
      editForm1.signData.push(JSON.parse(editForm.a3));
      editForm1.signData.push(JSON.parse(editForm.a4));
      editForm1.signData.push(JSON.parse(editForm.a5));
      editForm1.signData.push(JSON.parse(editForm.a6));
      editForm1.signData.push(JSON.parse(editForm.a7));
      this.editForm = editForm1;
    },
    // 筛选
    select() {
      this.pageNum = 1;
      this.getList();
    },
    // 获取表单信息
    getList() {
      var params = {
        pageNumber: this.pageNum,
        pageSize: this.pageSize,
      };
      this.loading = true;
      this.$refs.gridTable.bodyWrapper.scrollTop = 0;
      this.$api.operate
        .signConfigList(params)
        .then((res) => {
          this.tableData = res.records;
          this.total = res.total;
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // 选择或者取消行，支持全选
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 关闭添加弹窗
    handleClose() {
      this.$refs.active.resetFields();
    },
    // 关闭修改弹窗
    editClose(done) {
      this.editInfo = {};
      done();
    },
    // 删除选中项
    handleDel() {
      var ids = [];
      this.multipleSelection.forEach((item) => {
        ids.push(item.id);
      });
      var params = {
        ids: ids.toString(),
      };
      this.$api.operate
        .signConfigDelete(params)
        .then((res) => {
          this.$message.success(res);
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.getList();
        });
    },
    // 打开添加弹窗
    open() {
      this.dialogVisible = true;
      this.active = {
        num: "",
        signData: [
          {
            day: 1,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 2,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 3,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 4,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 5,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 6,
            amount: 0,
            level: 0,
            c0: 0,
          },
          {
            day: 7,
            amount: 0,
            level: 0,
            c0: 0,
          },
        ],
      };
    },
    happenTimeFun(num) {
      let date = new Date(num);
      //时间戳为10位需*1000，时间戳为13位的话不需乘1000
      let y = date.getFullYear();
      let MM = date.getMonth() + 1;
      MM = MM < 10 ? "0" + MM : MM; //月补0
      let d = date.getDate();
      d = d < 10 ? "0" + d : d; //天补0
      let h = date.getHours();
      h = h < 10 ? "0" + h : h; //小时补0
      let m = date.getMinutes();
      m = m < 10 ? "0" + m : m; //分钟补0
      let s = date.getSeconds();
      s = s < 10 ? "0" + s : s; //秒补0
      return y + "-" + MM + "-" + d;
    },
    // 添加用户
    bannerSave() {
      this.$api.operate
        .signConfigSave(this.active)
        .then((res) => {
          this.$message.success(res);
          this.dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 添加用户
    update() {
      this.$api.operate
        .signConfigUpdate(this.editForm)
        .then((res) => {
          this.$message.success(res);
          this.edit_dialogVisible = false;
          this.getList();
        })
        .catch((err) => {
          this.$message.error(err || "服务器错误，请稍后重试");
        })
        .finally(() => {
          this.buttongLoding = false;
        });
    },
    // 打开删除弹窗
    openDelete() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        return this.$message.info("你并没有选中任何选项");
      }
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.handleDel();
        })
        .catch(() => {});
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .el-radio-group {
  align-items: center;
}
.input {
  color: red !important;
}
.flex {
  display: flex;
  align-content: center;
  flex-wrap: wrap;
}
.role_warp {
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 10px;
  box-sizing: border-box;
  .role_heard_tool {
    margin-bottom: 10px;
  }
  .edit_titile {
    .dialog_input {
      // width: 100%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      width: 70%;
      span {
        flex: 1;
        display: flex;
        justify-content: flex-end;
        margin-right: 20px;
      }
      .el-input {
        flex: 3;
      }
    }
  }
  .tree {
    margin-top: 25px;
    display: flex;
    justify-content: space-around;
  }
  .authority_info {
    margin-top: 25px;
  }
}
.el-input {
  width: 70%;
}
</style>
